import * as React from 'react'
import {ILoginModalProps} from "./ILoginModalProps";
import {ILoginModalState} from "./ILoginModalState";
import ReactModalLogin from 'react-modal-login';
import man from 'src/assets/images/man.png'
import facebook from 'src/assets/images/facebook-logo.png'
import {facebookConfig, googleConfig} from "../../api/config";
import {connect} from 'react-redux'
import Popup from "reactjs-popup";
import * as actions from 'src/actions/userAction';
import * as modalActions  from 'src/actions/modalActions'
import 'src/assets/css/modal.css';
import Loader from 'react-loader-spinner'

import {Button, Header, Icon, Image, Modal , Tab} from 'semantic-ui-react'
import {type} from "os";

class LoginModal extends React.Component<ILoginModalProps, ILoginModalState> {

    constructor(props: ILoginModalProps) {
        super(props)
        this.state = {
            showModal: false,
            loggedIn: null,
            loading: false,
            error: null,
            initialTab: null,
            recoverPasswordSuccess: null,
            email : '' ,
            password :'' ,
            newEmail : '' ,
            newPassword :'' ,
            newUserName : ''

        };
    }

    componentWillReceiveProps(nextProps: Readonly<ILoginModalProps>, nextContext: any): void {
        console.log(nextProps, 'next prooops')
        if (nextProps.errorMessage) {
            this.setState({
                error: true,
                loading: false
            })
        }

    }

    componentWillMount(): void {
        console.log(this.props, 'prooop')

        if (this.props.errorMessage) {
            this.setState({
                error: true,
                loading: false
            })
        }

    }

    facebooklogin() {
        console.log('fffffffff')
        // event.preventDefault()
        this.setState({
            loading: true,
            error: false
        })

        this.props.handleSignUpWithFacebook(() => {
            console.log('facebook')
            this.setState({
                loading: false
            })
        })
    }


    loginWithEmail() {

        event.preventDefault();
        this.setState({
            loading: true,
            error: false
        })

        this.props.handleSignIn({
           email: this.state.email, password: this.state.password}, () => {
            console.log(this.state.email, this.state.password, 'aaaaaa');
            this.setState({
                loading: false
            })
        });


    }

    registerWithEmail() {
        this.setState({
            loading: true,
            error: false
        })
        event.preventDefault()

        this.props.handleSignUp({email : this.state.newEmail, password : this.state.newPassword, username : this.state.newUserName
        }, () => {
            console.log('UP')
            this.setState({
                loading: false
            })

        });
    }


    render() {

        const loggedIn = this.state.loggedIn
        const panes = [
            { menuItem: 'Connexion', render: () => <Tab.Pane>
                    <div className={'Tabs'}>

                    <div className="tabs-content">

                    <form onSubmit={() => this.loginWithEmail()}>
                    {!isLoading ? <div>
                            <div className="input_ctrl">
                                <input type="texte" name="email " value={this.state.email}
                                       onChange={(event)=>{
                                           this.setState({
                                               email: event.target.value
                                           })
                                       }}
                                       placeholder="Email"/>
                            </div>
                            <div className="input_ctrl">
                                <input type="password" name="" placeholder="password"
                                       value={this.state.password}
                                       onChange={(event)=>{
                                           this.setState({
                                               password: event.target.value
                                           })
                                       }}

                                />
                            </div>


                            <div className="input_ctrl">
                                <button type='submit'>LogIn</button>
                            </div>

                            <div className="smedia" style={{cursor: 'pointer'}}
                                 onClick={() => this.facebooklogin()}>
                                <div
                                    style={{
                                        width: '35px',
                                        marginBottom: 'auto',
                                        marginLeft: '25%',
                                        marginTop: 'auto',
                                        marginRight: '5%'
                                    }}

                                ><img src={facebook} alt="" onClick={() => this.facebooklogin()}/></div>
                                <p style={{
                                    color: 'white'
                                }}>Continuer avec facebook</p>
                            </div>
                            {this.state.error  &&
                        (this.props.errorMessage.split("/")[0] === 'The email address is badly formatted.'
                            ||
                            this.props.errorMessage.split("/")[0] === 'The password is invalid or the user does not have a password.'

                        )?

                                <p className='errormsg'>
                                    L'adresse email ou le mot de passe est incorrect
                                </p> : null
                            }
                        </div> :
                        <div
                            style={{

                                marginLeft: '323px',
                                marginTop: '90px'
                            }}

                        ><Loader type="CradleLoader" color="#f34c71" height={40} width={40}/></div>
                    }

                </form>
                    </div>
                    </div>
                    </Tab.Pane> },
            { menuItem: 'inscription', render: () => <Tab.Pane>
                    <div className={'Tabs'}>

                    <div className="tabs-content">
                    <form>
                    {!isLoading ?
                        <div>
                            <div className="input_ctrl">
                                <input type="texte" name="" placeholder="User name"
                                       value={this.state.newUserName}
                                       onChange={(event)=>{
                                           this.setState({
                                               newUserName: event.target.value
                                           })
                                       }}
                                />
                            </div>
                            <div className="input_ctrl">
                                <input type="texte" name="" placeholder="Email"

                                       value={this.state.newEmail}
                                       onChange={(event)=>{
                                           this.setState({
                                               newEmail: event.target.value
                                           })
                                       }}
                                />
                            </div>
                            <div className="input_ctrl">
                                <input type="password" name=""
                                       placeholder="Password"
                                       value={this.state.newPassword}
                                       onChange={(event)=>{
                                           this.setState({
                                               newPassword: event.target.value
                                           })
                                       }}
                                />
                            </div>

                            <div className="input_ctrl">
                                <button onClick={() => this.registerWithEmail()}>Sign up
                                </button>
                            </div>

                            <div className="smedia" style={{cursor: 'pointer'}}
                                 onClick={() => this.facebooklogin()}>
                                <div
                                    style={{
                                        width: '35px',
                                        marginBottom: 'auto',
                                        marginLeft: '25%',
                                        marginTop: 'auto',
                                        marginRight: '5%'
                                    }}

                                ><img src={facebook} alt="" onClick={() => this.facebooklogin()}/></div>
                                <p style={{
                                    color: 'white'
                                }}>Continuer avec facebook</p>
                            </div>
                            {/*{this.state.error ? <p className='errormsg'>
                                {this.props.errorMessage.split("/")[0]}</p> : null
                            }*/}
                        </div>

                        :
                        <div
                            style={{

                                marginLeft: '323px',
                                marginTop: '90px'
                            }}

                        >
                            <Loader type="CradleLoader" color="#f34c71" height={40} width={40}/></div>
                    }

                </form>
                        </div>
                    </div>
                        </Tab.Pane> },
        ]

        const isLoading = this.state.loading;
        console.log(window.innerWidth, 'wwwwwwww')
        return (

            <div>


                <Modal
                    open={this.props.modalLogin}
                    centered={false}
                    onClose={()=>{

                        this.props.openLoginModal(!this.props.modalLogin , ()=>{
                            console.log('modal Colse')
                        })
                    }}
                    trigger={<label

                        style={{
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                        this.props.openLoginModal(!this.props.modalLogin , ()=>{
                            console.log('login modal open')
                        })
                    }}><img src={man}
                            style={{
                                cursor: 'pointer'
                            }}
                            alt=""/></label>
                    }>


                    <Modal.Content>

                        {/*    <div className="tabs">
                            <input className="radio" id="tab-1" name="tabs-name" type="radio" defaultChecked/>
                            <label htmlFor="tab-1" className="table"><span>Login</span></label>

                            <div className="tabs-content">
                                <form onSubmit={() => this.loginWithEmail()}>
                                    {!isLoading ? <div>
                                            <div className="input_ctrl">
                                                <input type="texte" name="email " value={this.state.email}
                                                       onChange={(event)=>{
                                                           this.setState({
                                                           email: event.target.value
                                                           })
                                                       }}
                                                       placeholder="Email"/>
                                            </div>
                                            <div className="input_ctrl">
                                                <input type="password" name="" placeholder="password"
                                                       value={this.state.password}
                                                       onChange={(event)=>{
                                                           this.setState({
                                                               password: event.target.value
                                                           })
                                                       }}

                                                     />
                                            </div>


                                            <div className="input_ctrl">
                                                <button type='submit'>LogIn</button>
                                            </div>

                                            <div className="smedia" style={{cursor: 'pointer'}}
                                                 onClick={() => this.facebooklogin()}>
                                                <div
                                                    style={{
                                                        width: '35px',
                                                        marginBottom: 'auto',
                                                        marginLeft: '25%',
                                                        marginTop: 'auto',
                                                        marginRight: '5%'
                                                    }}

                                                ><img src={facebook} alt="" onClick={() => this.facebooklogin()}/></div>
                                                <p style={{
                                                    color: 'white'
                                                }}>Continuer avec facebook</p>
                                            </div>
                                            {this.state.error ? <p className='errormsg'>
                                                {this.props.errorMessage.split("/")[0]}
                                            </p> : null
                                            }
                                        </div> :
                                        <div
                                            style={{

                                                marginLeft: '323px',
                                                marginTop: '90px'
                                            }}

                                        ><Loader type="CradleLoader" color="#f34c71" height={40} width={40}/></div>
                                    }

                                </form>


                            </div>
                            <input className="radio" id="tab-2" name="tabs-name" type="radio"/>
                            <label htmlFor="tab-2" className="table"><span>Inscription</span></label>
                            <div className="tabs-content">
                                <form>
                                    {!isLoading ?
                                        <div>
                                            <div className="input_ctrl">
                                                <input type="texte" name="" placeholder="User name"
                                                       value={this.state.newUserName}
                                                       onChange={(event)=>{
                                                           this.setState({
                                                               newUserName: event.target.value
                                                           })
                                                       }}
                                                />
                                            </div>
                                            <div className="input_ctrl">
                                                <input type="texte" name="" placeholder="Email"

                                                       value={this.state.newEmail}
                                                       onChange={(event)=>{
                                                           this.setState({
                                                               newEmail: event.target.value
                                                           })
                                                       }}
                                                />
                                            </div>
                                            <div className="input_ctrl">
                                                <input type="password" name=""
                                                       placeholder="Password"
                                                       value={this.state.newPassword}
                                                       onChange={(event)=>{
                                                           this.setState({
                                                               newPassword: event.target.value
                                                           })
                                                       }}

                                                />
                                            </div>

                                            <div className="input_ctrl">
                                                <button onClick={() => this.registerWithEmail()}>Sign up
                                                </button>
                                            </div>

                                            <div className="smedia" style={{cursor: 'pointer'}}
                                                 onClick={() => this.facebooklogin()}>
                                                <div
                                                    style={{
                                                        width: '35px',
                                                        marginBottom: 'auto',
                                                        marginLeft: '25%',
                                                        marginTop: 'auto',
                                                        marginRight: '5%'
                                                    }}

                                                ><img src={facebook} alt="" onClick={() => this.facebooklogin()}/></div>
                                                <p style={{
                                                    color: 'white'
                                                }}>Continuer avec facebook</p>
                                            </div>
                                            {this.state.error ? <p className='errormsg'>
                                                {this.props.errorMessage.split("/")[0]}</p> : null
                                            }
                                        </div>

                                        :
                                        <div
                                            style={{

                                                marginLeft: '323px',
                                                marginTop: '90px'
                                            }}

                                        >
                                            <Loader type="CradleLoader" color="#f34c71" height={40} width={40}/></div>
                                    }

                                </form>
                            </div>
                        </div>*/}
                        <Tab
                            menu={{
                                attached: true,
                                tabular: true,
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                }
                            }}


                            panes={panes} />

                </Modal.Content>

                </Modal>

            </div>
        )
    }

}

const mapDispatchToProps = (dispatch: any, ownProps: ILoginModalProps) => {
    return {
        handleSignUpWithFacebook: (cb) => dispatch(actions.handleSignUpWithFacebook(cb)),
        handleSignUp: (form, cb) => dispatch(actions.signup(form, cb)),
        handleSignIn: (form, cb) => dispatch(actions.signin(form, cb)),
        openLoginModal: (type , cb) => dispatch(modalActions.loginModal(type, cb))
    }
}


function mapsStateToProps(state) {
    return {errorMessage: state.auth.errorMessage ,
        modalLogin: state.modal.loginModal
    };
}

export default connect(mapsStateToProps, mapDispatchToProps)(LoginModal);




// WEBPACK FOOTER //
// ./src/components/loginModal/LoginModal.tsx